export default "__VITE_ASSET__34b773a1__"